function loadImage(element) {
    if (typeof $(element).attr("data-add-class-on-intersect") != "undefined" && 
        $(element).attr("data-add-class-on-intersect") != "") {
        $(element).addClass($(element).attr("data-add-class-on-intersect"));
        //$(element).addClass("js-lazy-load__fade-in");
    } else
    if (typeof $(element).attr("data-add-style-on-intersect") != "undefined" && 
        $(element).attr("data-add-style-on-intersect") != "") {
        $(element).attr("style", $(element).attr("data-add-style-on-intersect"));
        //$(element).addClass("js-lazy-load__fade-in");        
    } else
    if (typeof $(element).attr("data-assign-src-on-intersect") != "undefined" && 
        $(element).attr("data-assign-src-on-intersect") != "") {
        $(element).attr("src", $(element).attr("data-assign-src-on-intersect"));
        $(element).removeClass("js-lazy-load__hidden");
    } 

   
}

function handleIntersection(entries, observerObj) {

    entries.forEach(function(entry, i) {

        if(!entry.isIntersecting) return;      
        
        const element = $(entry.target);
  
        loadImage(element);

        observerObj.unobserve(entry.target);                
    });
}

function initIntersectObserve() {
    
    /*
    $(".js-lazy-load").each(function(index , element) {
        if (typeof $(element).attr("data-add-style-on-intersect") != "undefined" && 
            $(element).attr("data-add-style-on-intersect") != "") {
            $(element).addClass("js-lazy-load__fade");
        }
    }); 
    */

    const isInKenticoCMSPageBuilder = $(".cms-bootstrap").length > 0;
  
    if (typeof IntersectionObserver != "undefined" && !isInKenticoCMSPageBuilder) {
        const observerOptions : any = {
            threshold: 0.05
        };
            
        const observer = new IntersectionObserver(handleIntersection, observerOptions);
        
        $(".js-lazy-load").each(function(index , element) {
            observer.observe($(element)[0]);
        });           
        
    } else {
        $(".js-lazy-load").each(function(index , element) {
            loadImage(element);
        });        
    } 

    return true;
  }

  function forceLazyload() {
    $(".js-lazy-load").each(function(index , element) {
        loadImage(element);
    });   
  }
  
  export { initIntersectObserve, forceLazyload };